"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var versionSelectorBaseTheme = function (_a) {
    var _b;
    var MAX_S = _a.MAX_S;
    return ({
        versionSelector: {
            display: "inline-block",
        },
        versionSelectorItemPrefix: {
            display: "inline"
        },
        versionSelectorItemLabel: {
            display: "inline",
            textTransform: 'uppercase'
        },
        versionSelectorItem: {
            display: "flex",
            alignItems: "center",
            alignContent: "center",
            fontWeight: 600,
            marginTop: "0.5rem",
            '& a': {
                textDecoration: 'none'
            }
        },
        versionSelectorButton: (_b = {
                margin: 0,
                marginRight: 0,
                padding: "0.25rem 0.5rem"
            },
            _b[MAX_S] = {
                padding: "0rem 0.5rem",
                "& i18n-message": {
                    fontWeight: "bold",
                    fontSize: "0.75rem",
                },
                display: "inline-block"
            },
            _b),
        versionSelectorCurrentPrefix: {},
        versionSelectorCurrent: {
            display: "flex",
            alignItems: "center",
            alignContent: "center",
            textTransform: 'none',
            fontSize: "0.75rem",
        },
        versionSelectorCurrentLabel: {
            textTransform: 'uppercase'
        },
    });
};
exports.default = versionSelectorBaseTheme;
//# sourceMappingURL=versionSelector.js.map